document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('body.home header');
  const stickyHeader = document.querySelector('header.sticky-top');

  if (!header || !stickyHeader) return;

  let lastState = false;

  window.addEventListener('scroll', () => {
    const shouldHide = window.scrollY >= 100 && window.innerWidth > 769;

    if (shouldHide !== lastState) {
      header.classList.toggle('header-hidden', shouldHide);
      stickyHeader.classList.toggle('is-visible', shouldHide);
      lastState = shouldHide;
    }
  });
});

// document.querySelectorAll('.dropdown-toggle').forEach(function(toggle) {
//   toggle.addEventListener('click', function(e) {
//     // Get the dropdown instance
//     var dropdown = bootstrap.Dropdown.getOrCreateInstance(this);

//     // If dropdown is already open, follow the link normally
//     if (this.classList.contains('show') || this.nextElementSibling.classList.contains('show')) {
//       return; // default behavior: navigate to href
//     }

//     // First click: prevent navigation, just toggle dropdown
//     e.preventDefault();
//     dropdown.toggle();
//   });
// });

// document.addEventListener('DOMContentLoaded', function () {
//     const navLinks = document.querySelectorAll('.nav-item.dropdown > a.nav-link');

//     navLinks.forEach(link => {
//         link.addEventListener('click', function (e) {
//             // Only prevent default if navbar is collapsed (mobile)
//             const navbar = link.closest('.navbar');
//             const toggler = navbar.querySelector('.navbar-toggler');
//             // console.log(navbar);
//             // console.log(toggler);
            
//             if (toggler && window.getComputedStyle(toggler).display !== 'none') {
//                 // Mobile menu is active
//                 e.preventDefault();
//                 // Optionally toggle dropdown programmatically
//                 const dropdown = bootstrap.Dropdown.getOrCreateInstance(
//                     link.nextElementSibling
//                 );
//                 dropdown.toggle();
//             }
//         });
//     });
// });

// document.addEventListener('DOMContentLoaded', function () {
//   const dropdownToggles = document.querySelectorAll(
//     '.navbar .dropdown-toggle'
//   );
//   console.log(dropdownToggles);
  
//   dropdownToggles.forEach(toggle => {
//     let tapped = false;

//     toggle.addEventListener('click', function (e) {
//       if (!tapped) {
//         e.preventDefault();
//         tapped = true;

//         // reset if user taps elsewhere
//         document.addEventListener('click', function reset() {
//           tapped = false;
//           document.removeEventListener('click', reset);
//         });
//       }
//     });
//   });
// });
// document.addEventListener('DOMContentLoaded', function () {
//     const dropdownToggles = document.querySelectorAll('.dropdown-toggle');

//     dropdownToggles.forEach(function (toggle) {
//         toggle.addEventListener('click', function (e) {
//             const parentLi = toggle.parentElement;
//             if (!parentLi.classList.contains('show')) {
//                 e.preventDefault(); // open dropdown on first click
//             }
//         });
//     });
// });

// document.querySelectorAll('.nav-item.dropdown > .dropdown-toggle').forEach(function(dropdown) {
//   // Hover to open dropdown
//   dropdown.parentElement.addEventListener('mouseenter', function() {
//     dropdown.classList.add('show');
//     dropdown.nextElementSibling.classList.add('show');
//   });
//   dropdown.parentElement.addEventListener('mouseleave', function() {
//     dropdown.classList.remove('show');
//     dropdown.nextElementSibling.classList.remove('show');
//   });

//   // Click to navigate
//   dropdown.addEventListener('click', function(e) {
//     window.location.href = dropdown.getAttribute('href');
//   });
// });





document.addEventListener('DOMContentLoaded', function() {
    const buttons = document.querySelectorAll('.filter-btn');
    const cards = document.querySelectorAll('.post-card.col-md-4');
    buttons.forEach(btn => {
        btn.addEventListener('click', function() {
            const cat = this.getAttribute('data-category');
            buttons.forEach(b => b.classList.remove('active'));
            this.classList.add('active');
            cards.forEach(card => {
                const cardCat = card.getAttribute('data-category');
                if (cat === 'all' || (cardCat && cardCat === cat.toLowerCase())) {
                    card.style.display = '';
                } else {
                    card.style.display = 'none';
                }
            });
        });
    });
});


